import React from "react";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3Table from "../../../../core/et3-table";
import Et3Margin from "../../../../core/et3-ui/ET3Margin";
import i18n from "../../../../constants/i18n";
import getOtherAuditorsPerformanceStore from "../../../../stores/supervisor-store/other-auditors-performance-store";
import {
  SUPERVISOR_OTHER_AUDITORS_EFFICIENCY_HEADERS,
  SUPERVISOR_OTHER_AUDITORS_PERFORMANCE_HEADERS
} from "../../../../constants/table-custom-headers/Supervisor";

const PerformanceData = withLiteObserverAndTheme(() => {
  const auditorsPerformance =
    getOtherAuditorsPerformanceStore().auditPerformanceOrdered.get();
  const auditorsEfficiency =
    getOtherAuditorsPerformanceStore().getOtherAuditorsEfficiencyData();

  return (
    <React.Fragment>
      <Et3Table
        columns={SUPERVISOR_OTHER_AUDITORS_PERFORMANCE_HEADERS}
        rows={auditorsPerformance}
        title={i18n.get("AUDITING_PERFORMANCE")}
        shouldBeFlagged={false}
        titleKey={"AUDITING_PERFORMANCE"}
      />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <Et3Table
        columns={SUPERVISOR_OTHER_AUDITORS_EFFICIENCY_HEADERS}
        rows={auditorsEfficiency}
        title={i18n.get("AUDITORS_EFFICIENCY")}
        shouldBeFlagged={false}
        titleKey={"AUDITORS_EFFICIENCY"}
      />
    </React.Fragment>
  );
});

export default PerformanceData;
